import { render, staticRenderFns } from "./box.vue?vue&type=template&id=118e8bbe"
var script = {}
import style0 from "./box.vue?vue&type=style&index=0&id=118e8bbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports